import { getResourceLibrary } from "@/requests/libraries/get-resource-library.request";
import { useQuery } from "@tanstack/react-query";
import { useCurrentUserProfile } from "./current-user-profile.hook";

export const useResourceLibrary = () => {
  const { data: userProfile } = useCurrentUserProfile();

  const companyId = userProfile?.companyId || "";

  return useQuery({
    queryKey: ["companies", companyId, "resource-libraries"],
    queryFn: () => getResourceLibrary({ companyId }),
    enabled: !!companyId,
  });
};
